import { render, staticRenderFns } from "./SceneComponent.vue?vue&type=template&id=39f224e7"
import script from "./SceneComponent.vue?vue&type=script&lang=ts"
export * from "./SceneComponent.vue?vue&type=script&lang=ts"
import style0 from "./SceneComponent.vue?vue&type=style&index=0&id=39f224e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports